export default {
  woundCompression: {
    goalParameterList: [],
    selectedCompression: '',
  },
};
